import { Field } from 'react-final-form'
import { useLocation, useNavigate, useParams } from 'react-router'
import { FlexRow, TextSpan } from '../components'

export function suffixWrapper(Component, label) {
  return (
    <FlexRow childMargin wrap='no-wrap'>
      {Component}
      <TextSpan>{label}</TextSpan>
    </FlexRow>
  )
}

export const Fields = ({ names, subscription, fieldsState = {}, children, originalRender }) => {
  if (!names.length) {
    return (originalRender || children)(fieldsState)
  }
  const [name, ...rest] = names
  return (
    <Field name={name} subscription={subscription}>
      {fieldState => (
        <Fields
          names={rest}
          subscription={subscription}
          originalRender={originalRender || children}
          fieldsState={{ ...fieldsState, [name]: fieldState }}
        />
      )}
    </Field>
  )
}

export function withRouterProps(WrappedComponent) {
  return function WrapperComponent(props) {
    const params = useParams()
    const location = useLocation()
    const navigate = useNavigate()
    return (
      <WrappedComponent {...props} match={{ params }} location={location} navigate={navigate} />
    )
  }
}
